import axios from "axios";

import APIRoutes from "../../APIRoutes";

import ISonicChatroom from "../../../common/classes/SonicChatroom";

import { getChatRoot } from "../../../utils/GeneralUtils";
import { getChatSocket } from "../../socket/useSocket";
import SocketClientEvents from "../../socket/SocketClientEvents";

/**
 * postCreateChatroom
 *
 * Fetching chat rooms associated with users.
 *
 * @typedof Chatroom
 * @property {ISonicChatroom} room Chat room id and users
 * @property {number} unreadCount Number of unread messages
 *
 * @param {string} auth_token The user's auth token, used for fetching data that requires certain privileges.
 * @param {string} user The user's auth token, used for fetching data that requires certain privileges.
 * @param {string} requestType request type of requestor.
 * @param {string} relation Id of requestor.
 * @returns {Promise<Chatroom[] | null>} An array of chatroom.
 */

export const postCreateChatroom = async (
  auth_token: string,
  user: string,
  requestType: "offer" | "project",
  relation: string
): Promise<ISonicChatroom[] | null> => {
  try {
    const res = await axios.post(
      getChatRoot(APIRoutes.chat.create),
      {
        user: user,
        requestType: requestType,
        relation: relation,
      },
      {
        headers: {
          "X-Sonic-Auth": auth_token,
        },
      }
    );

    if (res.data.result === false) return null;

    const socket = getChatSocket();
    socket.emit(
      SocketClientEvents.createdRoom,
      [user],
      res.data.message.id,
      true
    );
    return res.data;
  } catch (e) {
    return null;
  }
};
